import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ez-sso-button',
  imports: [
    MatButtonModule,
  ],
  templateUrl: './sso-button.component.html',
  styleUrls: ['./sso-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SsoButtonComponent implements OnInit {
  lastSsoProvider: string | null = null;
  challengeUrl: string | null = null;

  ngOnInit(): void {
    this.lastSsoProvider = localStorage.getItem("lastSsoProvider");
    this.challengeUrl = localStorage.getItem("challengeUrl");
  }
}
